{
  "version": 1,
  "asset_id": "a49fdca3-1cf1-4ff1-86d9-75521564d375",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a49fdca3-1cf1-4ff1-86d9-75521564d375/sleeve-ugi-normal-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a49fdca3-1cf1-4ff1-86d9-75521564d375/sleeve-ugi-normal-800.webp",
  "original_filename": "sleeve-ugi-normal-800.webp",
  "size": 67008,
  "content_type": "image/webp",
  "created_at": "2026-09-28T01:31:18Z"
}
